import { useCallback } from 'react';

import { SelectPesquisavel } from './select-pesquisavel';

export interface MunicipioOpcao {
  codigo: string;
  nome: string;
}

/** Busca no servidor os municípios da UF que casam com o termo (poucos por vez). */
export type BuscarMunicipios = (
  uf: string,
  termo: string,
  signal: AbortSignal,
) => Promise<readonly MunicipioOpcao[]>;

interface SeletorMunicipioProps {
  /** Cascata: sem UF o combo fica desabilitado e nada é consultado. */
  uf: string | null | undefined;
  valor: MunicipioOpcao | null;
  aoMudar: (municipio: MunicipioOpcao | null) => void;
  buscar: BuscarMunicipios;
  id?: string;
  'aria-label'?: string;
  'aria-invalid'?: true;
  'aria-describedby'?: string;
  className?: string;
  disabled?: boolean;
}

/**
 * Cidade em cascata com o estado, em modo REMOTO: só consulta ao abrir/digitar, nunca a lista
 * inteira. O valor gravado (código IBGE + nome) é exibido sem requisição nenhuma.
 */
export function SeletorMunicipio({ uf, valor, aoMudar, buscar, ...resto }: SeletorMunicipioProps) {
  const buscarNaUf = useCallback(
    async (termo: string, signal: AbortSignal) =>
      uf ? (await buscar(uf, termo, signal)).map((m) => ({ valor: m.codigo, rotulo: m.nome })) : [],
    [buscar, uf],
  );
  return (
    <SelectPesquisavel
      {...resto}
      buscar={buscarNaUf}
      valor={valor?.codigo ?? null}
      opcaoSelecionada={valor ? { valor: valor.codigo, rotulo: valor.nome } : null}
      aoMudar={(_codigo, opcao) => {
        aoMudar(opcao ? { codigo: opcao.valor, nome: opcao.rotulo } : null);
      }}
      rotuloBusca="Buscar cidade"
      placeholder="Escolha a cidade"
      vazio="Nenhuma cidade encontrada."
      disabled={!uf || resto.disabled === true}
      {...(uf ? {} : { textoDesabilitado: 'Escolha o estado primeiro' })}
    />
  );
}
